import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class StackedRadialChart extends Vue {
  @Prop() propertiesToChart!: {
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
    groupBy: DynamicSelectData[];
    chartColor: { hex: string };
  };

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  chartOptions = {
    legend: {},
    series: [],
    angleAxis: {},
    radiusAxis: {},
    polar: {},
    color: []
  };
  readyToRender = false;
  mounted() {
    console.log("mounted stackedbar", this.propertiesToChart.groupBy);
    this.chart();
  }

  chart() {
    const section = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ];
    if (!section || !section.collections?.[0]?.chartData?.data) {
      console.warn("chartData no está disponible todavía");
      return;
    }
    const dataToGraph = section.collections[0];
    const chartData = dataToGraph.chartData;

    const series = chartData.data.map((item: any) => ({
      name: item.name == "" ? "Sin Info" : item.name,
      type: "bar",
      stack: item.stack,
      label:
        item.labelBar != ""
          ? {
              show: true,
              formatter: item.stack,
              position: "outside",
              color: "#000",
              fontSize: 45
            }
          : { show: false },
      data: item.data,
      coordinateSystem: "polar"
    }));
    const groups = Object.values(chartData.groups);
    const groupForLegend: string[] = groups[groups.length - 1] as string[];
    this.chartOptions = {
      color: Utils.generateColorsTones(
        this.propertiesToChart.chartColor.hex,
        3
      ) as never[],
      legend: {
        show: true,
        data: groupForLegend.map((e: any) => (e == "" ? "Sin Info" : e))
      },
      series,
      angleAxis: {
        type: "category",
        data: chartData.xAxis,
        splitLine: {
          show: true,
          lineStyle: {
            color: "#999",
            width: 1,
            type: "solid"
          }
        }
      },
      radiusAxis: {},
      polar: {}
    };
  }
}
